import TomSelect from "tom-select";
window.TomSelect = TomSelect;
// CSS 
import 'tom-select/dist/css/tom-select.bootstrap5.min.css';